module.exports = __webpack_public_path__ + "static/media/quite-impressed.c6e2a404.ogg";